const style = {
  span: {
    display: `block`,
    fontSize: `13px`
  },
  date: {
    fontSize: `14px`
  },
  spanCenter: {
    textAlign: `center`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Main/partials/BillingTable/style/transaction.js